import * as React from "react";
import { CollapseProvider } from "../../collapse/collapse-provider/collapse-provider.mjs";
import { CollapseLayerGridContext } from "../collapse-layer-grid/collapse-layer-grid.mjs";
const _CollapseLayerProvider = class _CollapseLayerProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trigger: null
    };
  }
  render() {
    const contextProps = {
      isVisible: this.context.activeCollapse === this.props.id,
      onToggle: (isVisible) => {
        this.context.setActiveCollapse(isVisible ? this.props.id : null);
        if (this.props.onToggle) {
          this.props.onToggle(isVisible);
        }
      },
      portal: this.state.trigger ? this.context.getPortal(this.state.trigger) : this.props.portal,
      triggerRef: (element) => {
        if (element && this.state.trigger !== element) {
          this.setState({
            trigger: element
          });
        }
      }
    };
    return /* @__PURE__ */ React.createElement(CollapseProvider, { ...this.props, ...contextProps });
  }
};
_CollapseLayerProvider.contextType = CollapseLayerGridContext;
let CollapseLayerProvider = _CollapseLayerProvider;
export {
  CollapseLayerProvider
};
